// Governance History API — 화면 4 탭 6-D (GovernanceContext 이력).
// 권위: ARCH_DASHBOARD.md v1.7 §4.4 탭 6-D.
//
// GET /api/v1/data/governance-history?from=&to=&stage=&override_only=&page=&size=
// 응답: GovernanceHistoryListResponse — trading_date DESC 정렬.

import { apiGet } from './client';

// Stage A/B/C/D (MarketPhase 8단계 폐기 — ARCH_OVERVIEW.md v1.5).
export type GovernanceStage = 'A' | 'B' | 'C' | 'D';
export const ALL_STAGES: GovernanceStage[] = ['A', 'B', 'C', 'D'];

export interface GovernanceHistoryItem {
  tradingDate: string;                         // "YYYY-MM-DD"
  stage: GovernanceStage | string;             // A/B/C/D
  totalScore: number | null;
  prevTotalScore?: number | null;              // Δ 계산용 (백엔드가 쥐어주지 않으면 클라이언트가 rolling 계산)
  trendScore: number | null;
  spreadScore: number | null;
  breakoutScore: number | null;
  damageScore: number | null;                  // v2.1.1 — 손상 스코어
  maxInvestRatio: number | null;               // 0~1
  overrideRapidDropActive: boolean;
  overrideRapidDropReason: string | null;
  overrideRapidDropTriggeredAt: string | null;
  overrideVolatilityActive: boolean;
  overrideVolatilityReason: string | null;
  overrideVolatilityTriggeredAt: string | null;
  // LLM Override (지점 F — Type-A/B 모드 확장)
  llmOverrideRolloutMode?: string | null;      // "shadow" | "canary" | "active" 등
  llmOverrideDelta?: number | null;            // LLM 제안 delta (total_score 대비)
  llmOverrideReasoning?: string | null;        // 상세 근거 (상세 모달 전용)
  updatedAt?: string | null;
}

export interface GovernanceHistoryListResponse {
  items: GovernanceHistoryItem[];
  total: number;
  page: number;
  size: number;
}

export interface GovernanceHistoryQuery {
  from?: string;                               // "YYYY-MM-DD"
  to?: string;
  stage?: GovernanceStage[];
  overrideOnly?: boolean;
  page?: number;
  size?: number;
}

function buildQuery(q: GovernanceHistoryQuery): URLSearchParams {
  const p = new URLSearchParams();
  if (q.from) p.set('from', q.from);
  if (q.to) p.set('to', q.to);
  if (q.stage && q.stage.length > 0) p.set('stage', q.stage.join(','));
  if (q.overrideOnly) p.set('override_only', 'true');
  p.set('page', String(Math.max(0, q.page ?? 0)));
  p.set('size', String(Math.max(1, Math.min(200, q.size ?? 50))));
  return p;
}

export async function listGovernanceHistory(
  query: GovernanceHistoryQuery = {},
): Promise<GovernanceHistoryListResponse> {
  const qs = buildQuery(query).toString();
  return apiGet<GovernanceHistoryListResponse>(
    `/api/v1/data/governance-history?${qs}`,
  );
}
